const notificationHu = {
	notificationTable: 'Notification',
	name: 'Name',
};

export default notificationHu;